import BackHeader from "@components/header/BackHeader";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { Flex } from "antd";
import { useTranslation } from "react-i18next";
import TossBillingButton from "./TossBillingButton";
import { useNavigate } from "react-router-dom";

const Container = styled.div(({ theme }) => ({
  padding: "2rem",
  backgroundColor: theme.color.white,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  minHeight: "calc(100dvh - 5.6rem)",
  position: "relative",
  justifyContent: "center",
}));

const ContentWrapper = styled.div({
  maxWidth: "48rem",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  // marginTop: "22.6rem",
});

const Title = styled.div(({ theme }) => ({
  fontSize: "2.4rem",
  textAlign: "center",
}));

const MessageBox = styled.div(({ theme }) => ({
  width: "100%",
  marginBottom: "3rem",
  fontWeight: theme.fontWeight.bold,
}));

const MessageItem = styled.li(({ theme }) => ({
  fontSize: "1.4rem",
  color: theme.color.gray,
  lineHeight: "2.4rem",
  position: "relative",
  paddingLeft: "2.6rem",
  display: "flex",
  flexDirection: "column",
  fontWeight: theme.fontWeight.regular,
  "&:before": {
    content: '"•"',
    position: "absolute",
    left: 10,
  },

  "&:last-child": {
    marginBottom: 0,
  },
}));

const Date = styled.div(({ theme }) => ({
  fontSize: "1.4rem",
  color: theme.color.gray,
  lineHeight: "2.4rem",
  fontWeight: theme.fontWeight.bold,
}));

const ButtonWrapper = styled.div({
  padding: "0 2rem",
  width: "100%",
  position: "absolute",
  bottom: "4.8rem",
});

const SubscribeFail = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const lang = localStorage.getItem("language");
  const navigate = useNavigate();

  return (
    <>
      <BackHeader title="구독" onClick={() => navigate(-1)} />

      <Container>
        <ContentWrapper>
          <Flex vertical align="center" gap={"4rem"}>
            <Image
              src={theme.image.fail_icon.default}
              width="6rem"
              height="6rem"
            />
            <Title>{t("구독 결제에 실패하였습니다")}</Title>
          </Flex>

          <ButtonWrapper>
            <MessageBox>
              <MessageItem>
                {t("구독을 신청하시려면 다시 시도해주세요.")}
              </MessageItem>
            </MessageBox>

            <TossBillingButton
              title="구독하기 재시도"
              width="100%"
              height="5.2rem"
            />
          </ButtonWrapper>
        </ContentWrapper>
      </Container>
    </>
  );
};

export default SubscribeFail;
